import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Switch,
  Modal,
  Upload,
  Table,
  message,
} from "antd";
import SubLayout from "../../components/layout/SubLayout";
import { permissionData } from "../../utils/constant";
import { useEffect, useRef, useState } from "react";
import DefaultCompanyLogo from "../../Assets/defaultCompanyLogo.svg";
import ThreeDSafetyLogo from "../../Assets/3d_safety_logo.png";
import PermissionIndividualCard from "../../components/common/UserManagement/PermissionIndividualCard";
import API_MANAGER from "../../API";
import PhoneInput from "react-phone-number-input";
import AlertState from "../../components/common/AlertState";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { useNavigate } from "react-router-dom";
import SearchIcon from "../../Assets/search_icon.svg";
import PermissionModal from "../UserManagement/permissionModal";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import moment from "moment";
import CustomPagination from "../../components/common/CustomPagination";
import { GoogleComponent } from "react-google-location";
import axios from "axios";
import { isRootUserByCompany } from "../../utils";
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
function EditProfile() {
  const [permissionIndex, setPermissionIndex] = useState();
  const [defaultPermissionIndex, setDefaultPermissionIndex] = useState();
  const [updatePermission, setUpdatePermission] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [userData, setUserData] = useState();
  const [address, setAddress] = useState(null);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [countryCode, setCountryCode] = useState("+61");
  const [id, setId] = useState();
  const [alertState, setAlertState] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [permissions, setPermissions] = useState([]);
  const [selectedCount, setSelectedCount] = useState(2);
  const [permissionModalOpen, setPermissionModalOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [imageChange, setImageChange] = useState(false);
  const [search, setSearch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const user = localStorage.getItem("user");
  const [campaignList, setCampaignList] = useState();
  const [fileList, setFileList] = useState([]);
  const [marketingPermission, setMarketingPermission] = useState(false);
  const [threeDSafetyModalOpen, setThreeDSafetyModalOpen] = useState(false);
  const [threeDSafetyLoading, setThreeDSafetyLoading] = useState(false);
  const [formThreeDSafety] = Form.useForm();
  const props = {
    name: "file",
    multiple: false,
    customRequest({ file, onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
  };
  const columns = [
    {
      title: "Campaign Name",
      dataIndex: "campaign",
      key: "campaignName",
      fixed: "left",
    },
    {
      title: "Job Advert",
      dataIndex: "jobTitle",
      key: "advertName",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "start_date",
      render: (item) => <span>{moment(item)?.format("DD MMM YYYY")}</span>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "end_date",
      render: (item) => <span>{moment(item)?.format("DD MMM YYYY")}</span>,
    },
    {
      title: "Status",
      dataIndex: "archive",
      render: (item) => {
        if (!item) {
          return <span className="Live_text">Live</span>;
        } else {
          return <span className="archived_text">Archived</span>;
        }
      },
      align: "center",
    },
  ];
  const navigate = useNavigate();
  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setImageChange(true);
    setFileList(newFileList);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  //API TO GET MY PROFILE DATA
  const getUserData = async () => {
    const params = {
      companyId: localStorage.getItem("clientId"),
    };
    try {
      const response = await API_MANAGER.getUserData(params);
      setData(response?.data?.data);
      setMarketingPermission(response?.data?.data?.marketingPermission);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  //USER DETAILS CARD API
  const SingleUserData = async () => {
    setLoading(true);
    try {
      const response = await API_MANAGER.getSingleUserData(
        localStorage.getItem("userID")
      );
      setUserData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  //change personal details API
  const onFinish = async (values) => {
    setLoading(true);
    values = { ...values, ["countryCode"]: countryCode };

    try {
      const response = await API_MANAGER.updateUserPersonalDetails(
        userData?.id,
        values
      );
      if (response?.data?.data?.firstName) {
        localStorage.setItem(
          "name",
          `${response?.data?.data?.firstName} ${response?.data?.data?.lastName}`
        );
        window.dispatchEvent(new Event("userNameChanged"));
      }
      SingleUserData();
      getUserData();
      setLoading(false);
      message.success("Profile successfully updated.");
    } catch (error) {
      setLoading(false);
      message.error("Something went wrong. Please try again.");
    }
  };
  //UPDATE COMPANY DETAILS API
  const companyDetailsOnFinish = async (values) => {
    setLoading(true);
    try {
      let imageData = null;
      if (imageChange && fileList.length > 0) {
        const dataImage = {
          extension:
            fileList?.length > 0 ? fileList[0]?.type.split("/")[1] : "",
          type: "PROFILE",
          contentType: fileList?.length > 0 ? fileList[0]?.type : "",
        };
        const responseImage = await API_MANAGER.fileUpload(dataImage);
        imageData = responseImage?.data?.data?.key;
        await axios.put(
          responseImage?.data?.data?.url,
          fileList[0]?.originFileObj
        );
        values.companyLogo = imageData;
      } else if (imageChange) {
        values.companyLogo = imageData;
      }

      await API_MANAGER.updateCompanyDetails(values);
      setLoading(false);
      message.success("Profile successfully updated.");

      // navigate(-1);
    } catch (error) {
      setLoading(false);

      message.error("Something went wrong. Please try again.");
    }
  };
  const getAdvertList = async () => {
    setLoading(true);
    try {
      const response = await API_MANAGER.getSingleUserCampaign();
      setCampaignList(response?.data?.data?.result);
    } catch (error) {
      message.error(error?.response?.data?.message?.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    getUserData();
    SingleUserData();
  }, []);

  useEffect(() => {
    if (user === "Associate") {
      getAdvertList();
    }
  }, [search]);

  useEffect(() => {
    form.setFieldsValue({
      companyName: data?.companyName,
      tradingName: data?.tradingName,
      companyAbn: data?.companyAbn,
      billingEmail: data?.billingEmail,
      billingName: data?.billingName,
      officeAddress: data?.officeAddress,
    });
    // Normalize address to ensure it has the correct structure
    if (data?.officeAddress) {
      const normalizedAddress = data.officeAddress;
      // If it's already in the correct format (has value property with place_id), use it as is
      if (normalizedAddress && 
          typeof normalizedAddress === 'object' && 
          normalizedAddress.value && 
          normalizedAddress.value.place_id) {
        setAddress(normalizedAddress);
      } else if (normalizedAddress && typeof normalizedAddress === 'object') {
        const placeId = normalizedAddress.place_id || normalizedAddress.value?.place_id || '';
        const structuredLabel = [
          normalizedAddress.street,
          normalizedAddress.city,
          normalizedAddress.state,
          normalizedAddress.postcode,
          normalizedAddress.country,
        ]
          .filter(Boolean)
          .join(", ");
        const label =
          normalizedAddress.label ||
          normalizedAddress.description ||
          structuredLabel ||
          "";

        setAddress({
          value: {
            place_id: placeId,
            description: normalizedAddress.description || label,
            ...(normalizedAddress.value || {}),
            ...(placeId ? {} : normalizedAddress),
          },
          label: label,
          description: normalizedAddress.description || label,
        });
      } else {
        // If it's a string or other format, we can't match it to options, so set to null
        // This prevents showing incorrect values
        setAddress(null);
      }
    } else {
      setAddress(null);
    }
    setId(userData?.id);
    setFileList((prevFileList) => [
      {
        ...prevFileList[0],
        url: data?.companyLogo,
      },
    ]);
  }, [data]);
  useEffect(() => {
    form1.setFieldsValue({
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      email: userData?.email,
      countryCode: userData?.countryCode,
      phoneNumber: userData?.phoneNumber,
    });
  }, [userData]);
  useEffect(() => {
    if (userData?.recruiterUserType === "Standard") {
      setPermissionIndex(1);
      setDefaultPermissionIndex(1);
    } else if (
      userData?.recruiterUserType === "Admin" ||
      userData?.recruiterUserType === null
    ) {
      setPermissionIndex(0);
      setDefaultPermissionIndex(0);
    } else {
      setPermissionIndex(2);
      setDefaultPermissionIndex(2);
    }
  }, [userData]);
  useEffect(() => {
    if (permissionIndex === 0) {
      setPermissions([0, 1, 2, 3, 4, 5]);
    } else if (permissionIndex === 1) {
      if (userData?.permissions) {
        setPermissions(userData?.permissions);
      } else {
        setPermissions([0, 1, 3, 4, 5]);
      }
    } else if (permissionIndex === 2) {
      setPermissions([4, 5]);
    } else {
      setPermissions([]);
    }
  }, [permissionIndex]);
  const isRootUser = isRootUserByCompany(userData, data);
  const handlePermissionModal = () => {
    if (isRootUser) return;
    if (permissions.length !== 0) setPermissionModalOpen(true);
    else {
      message.error("Permissions not selected yet.");
    }
  };

  const watchedFirstName = Form.useWatch("firstName", form1);
  const watchedLastName = Form.useWatch("lastName", form1);
  const watchedPhoneNumber = Form.useWatch("phoneNumber", form1);
  const isPersonalDetailsChanged =
    !!userData &&
    (String(watchedFirstName ?? "") !== String(userData?.firstName ?? "") ||
      String(watchedLastName ?? "") !== String(userData?.lastName ?? "") ||
      String(watchedPhoneNumber ?? "") !==
        String(userData?.phoneNumber ?? "") ||
      String(countryCode ?? "") !== String(userData?.countryCode ?? ""));

  const getInitialPermissions = (idx) => {
    if (idx === 0) return [0, 1, 2, 3, 4, 5];
    if (idx === 1) return userData?.permissions || [0, 1, 3, 4, 5];
    if (idx === 2) return [4, 5];
    return [];
  };
  const isPermissionChanged =
    !!userData &&
    (permissionIndex !== defaultPermissionIndex ||
      JSON.stringify([...(permissions || [])].sort((a, b) => a - b)) !==
        JSON.stringify(
          [...getInitialPermissions(defaultPermissionIndex)].sort(
            (a, b) => a - b
          )
        ));

  const watchedCompanyName = Form.useWatch("companyName", form);
  const watchedTradingName = Form.useWatch("tradingName", form);
  const watchedBillingName = Form.useWatch("billingName", form);
  const watchedBillingEmail = Form.useWatch("billingEmail", form);
  const watchedOfficeAddress = Form.useWatch("officeAddress", form);
  const getAddressLabel = (addr) => {
    if (!addr) return "";
    if (typeof addr === "string") return addr;
    if (addr?.label || addr?.description) {
      return addr.label || addr.description || "";
    }
    if (addr?.street || addr?.city || addr?.state || addr?.postcode) {
      return [addr.street, addr.city, addr.state, addr.postcode, addr.country]
        .filter(Boolean)
        .join(", ");
    }
    return "";
  };
  const isCompanyDetailsChanged =
    !!data &&
    (String(watchedCompanyName ?? "") !== String(data?.companyName ?? "") ||
      String(watchedTradingName ?? "") !== String(data?.tradingName ?? "") ||
      String(watchedBillingName ?? "") !== String(data?.billingName ?? "") ||
      String(watchedBillingEmail ?? "") !== String(data?.billingEmail ?? "") ||
      getAddressLabel(watchedOfficeAddress) !==
        getAddressLabel(data?.officeAddress) ||
      !!marketingPermission !== !!data?.marketingPermission ||
      imageChange);

  return (
    <SubLayout page={"Edit Profile"} whiteBg padding showBack>
      <FullScreenLoader isLoading={loading} />
      <AlertState
        state={alertState}
        message={alertMessage}
        alertOpen={alertOpen}
        setAlertOpen={setAlertOpen}
      />
      <PermissionModal
        permissionModalOpen={permissionModalOpen}
        setPermissionModalOpen={setPermissionModalOpen}
        singleUserData={userData}
        permissionIndex={permissionIndex}
        editUser={userData?.recruiterUserType}
        permissions={permissions}
        id={userData?.id}
        editProfile={"true"}
        isRootUser={isRootUser}
      />
      <Row className="profile_container">
        <Col xs={24}>
          {/* Personal Details */}
          <Col>
            <p className="heading">
              {userData?.firstName?.charAt(0).toUpperCase() +
                userData?.firstName?.slice(1) +
                " " +
                userData?.lastName?.charAt(0).toUpperCase() +
                userData?.lastName?.slice(1)}
            </p>
          </Col>
          <Form form={form1} layout="vertical" onFinish={onFinish}>
            <Col xs={24} className="personal_detail_container">
              <Col xs={24} className="form_title_container">
                <p className="form_title">Personal Details</p>
              </Col>
              <Col className="form_container">
                <Row gutter={100}>
                  <Col xs={12}>
                    <Form.Item label="First Name" name="firstName">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label="Last Name" name="lastName">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={100}>
                  <Col xs={12}>
                    <Form.Item label="Email*" name="email">
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <label className="custome_label">Contact Number</label>
                    <Row>
                      <Col xs={7} sm={6} lg={5}>
                        <Form.Item
                          name="countryCode"
                          rules={[
                            {
                              required: false,
                              message: "",
                            },
                          ]}
                        >
                          {/* components from other library */}
                          <PhoneInput
                            international
                            countryCallingCodeEditable={false}
                            className="w-100 emailInput PhoneInput"
                            defaultCountry="AU"
                            value={countryCode}
                            onChange={setCountryCode}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={17} sm={18} lg={19}>
                        <Form.Item
                          name="phoneNumber"
                          rules={[
                            {
                              required: true,
                              message: "",
                            },
                          ]}
                        >
                          <Input
                            placeholder="phone number"
                            type="phone"
                            className="form_input_box border_right_bottom"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row justify={"end"} gutter={16}>
                  <Col className="buttonCol">
                    <Form.Item>
                      <Button
                        className="button_cancel"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col className="buttonCol">
                    <Form.Item>
                      <Button
                        htmlType="submit"
                        className="button_update"
                        disabled={!isPersonalDetailsChanged}
                      >
                        Update
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Form>
          {/* Permissions */}
          {userData?.recruiterUserType !== "Associate" && (
            <Col
              span={24}
              className="personal_detail_container"
              style={{ margin: "20px 0px 40px 0px" }}
            >
              <Col xs={24} className="form_title_container">
                <p className="form_title">Permissions</p>
              </Col>
              <Col xs={24}>
                <Row justify={"center"} className="mt-24 mt-0 p-24" gutter={12}>
                  {permissionData.map((item, index) => (
                    <Col xs={24} lg={12} xl={8} className="cards_Col">
                      <PermissionIndividualCard
                        data={item}
                        index={index}
                        setPermissionIndex={setPermissionIndex}
                        permissionIndex={permissionIndex}
                        permissions={permissions}
                        setPermissions={setPermissions}
                        editUser={userData?.recruiterUserType}
                        selectedCount={selectedCount}
                        setSelectedCount={setSelectedCount}
                        userEditProfile={"yes"}
                        isRootUser={isRootUser}
                      />
                    </Col>
                  ))}
                </Row>
                <Row className="p-24" gutter={16} justify={"end"}>
                  <Col className="justify_items_end f_col_rev">
                    <Button
                      className="button_no_border button_no_border_sm"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col className="justify_items_end f_col_rev">
                    <Button
                      className="button_1 button_1_sm"
                      onClick={handlePermissionModal}
                      disabled={
                        isRootUser ||
                        !isPermissionChanged ||
                        permissions?.length === 0
                      }
                    >
                      Update
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Col>
          )}
          {/* Company Details */}
          {user !== "Associate" && user !== "Account" && (
            <Col xs={24} className="company_detail_container">
              <Form
                form={form}
                layout="vertical"
                onFinish={companyDetailsOnFinish}
              >
                <Col xs={24} className="form_title_container">
                  <p className="form_title">Company Details</p>
                </Col>
                <Col className="form_container">
                  <Row gutter={100}>
                    <Col xs={12}>
                      <Form.Item label="Company Name*" name="companyName">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={12}>
                      <Form.Item label="Trading Name" name="tradingName">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={100}>
                    <Col xs={12}>
                      <Form.Item label="ACN/ABN*" name="companyAbn">
                        <Input disabled={true} />
                      </Form.Item>
                    </Col>
                    <Col xs={12}>
                      <Form.Item
                        label="Registered Address*"
                        name="officeAddress"
                        className="googleApiContainer"
                      >
                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyDKh5aQsbsMQkM3r7VaiCPZhGrp_PGTw6I"
                          autocompletionRequest={{
                            componentRestrictions: {
                              country: ["au"], //to set the specific country
                            },
                            types: ["address"],
                          }}
                          selectProps={{
                            placeholder: "Add address",
                            value: address,
                            getOptionValue: (option) => {
                              // Always return a safe value - never throw
                              if (!option) return '';
                              
                              // Use optional chaining throughout
                              const placeId = option?.value?.place_id || option?.place_id;
                              if (placeId) return String(placeId);
                              
                              const label = option?.label || option?.value?.description || option?.description;
                              if (label) return String(label);
                              
                              return '';
                            },
                            isOptionEqualToValue: (option, value) => {
                              // Safely compare options
                              if (!option || !value) return false;
                              
                              try {
                                // Get place_id from both option and value
                                const optionPlaceId = option?.value?.place_id || option?.place_id;
                                const valuePlaceId = value?.value?.place_id || value?.place_id;
                                
                                // If both have place_id, compare them
                                if (optionPlaceId && valuePlaceId) {
                                  return String(optionPlaceId) === String(valuePlaceId);
                                }
                                
                                // Fallback to label comparison (case-insensitive)
                                const optionLabel = (option?.label || option?.value?.description || option?.description || '').trim();
                                const valueLabel = (value?.label || value?.value?.description || value?.description || '').trim();
                                
                                if (optionLabel && valueLabel) {
                                  return optionLabel.toLowerCase() === valueLabel.toLowerCase();
                                }
                                
                                return false;
                              } catch (error) {
                                return false;
                              }
                            },
                            onChange: async (selected) => {
                              if (!selected) {
                                form.setFieldsValue({ officeAddress: null });
                                setAddress(null);
                                return;
                              }
                              
                              // Check if selected has value and place_id exists
                              const placeId = selected?.value?.place_id;
                              
                              if (placeId && typeof placeId === 'string') {
                                try {
                                  // Get full place details to extract postal code
                                  const service = new window.google.maps.places.PlacesService(
                                    document.createElement('div')
                                  );
                                  
                                  service.getDetails(
                                    { placeId: placeId },
                                    (place, status) => {
                                      if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                                        // Extract address components
                                        const addressComponents = place.address_components || [];
                                        let suburb = '';
                                        let state = '';
                                        let postalCode = '';
                                        
                                        addressComponents.forEach((component) => {
                                          const types = component.types;
                                          if (types.includes('locality') || types.includes('sublocality')) {
                                            suburb = component.long_name;
                                          }
                                          if (types.includes('administrative_area_level_1')) {
                                            state = component.short_name; // Use short name for state abbreviation (QLD, NSW, etc.)
                                          }
                                          if (types.includes('postal_code')) {
                                            postalCode = component.long_name;
                                          }
                                        });
                                        
                                        // Format as "Suburb State PostalCode"
                                        let formattedAddress = suburb;
                                        if (state) {
                                          formattedAddress += ` ${state}`;
                                        }
                                        if (postalCode) {
                                          formattedAddress += ` ${postalCode}`;
                                        }
                                        
                                        // If no suburb found, use the place name
                                        if (!suburb && place.name) {
                                          formattedAddress = place.name;
                                          if (state) formattedAddress += ` ${state}`;
                                          if (postalCode) formattedAddress += ` ${postalCode}`;
                                        }
                                        
                                        const formattedValue = {
                                          value: {
                                            ...selected.value,
                                            place_id: placeId,
                                          },
                                          label: formattedAddress,
                                          description: formattedAddress,
                                        };
                                        
                                        form.setFieldsValue({ officeAddress: formattedValue });
                                        setAddress(formattedValue);
                                      } else {
                                        // Fallback to original selection
                                        form.setFieldsValue({ officeAddress: selected });
                                        setAddress(selected);
                                      }
                                    }
                                  );
                                } catch (error) {
                                  // Fallback to original selection
                                  form.setFieldsValue({ officeAddress: selected });
                                  setAddress(selected);
                                }
                              } else {
                                // If no place_id, just set the selected value directly
                                form.setFieldsValue({ officeAddress: selected });
                                setAddress(selected);
                              }
                            },
                            formatOptionLabel: (option) => {
                              // Access the raw Google Places prediction from value property
                              const rawPrediction = option?.value || {};
                              const structuredFormatting = rawPrediction?.structured_formatting || option?.structured_formatting || {};
                              
                              // Get text sources
                              const mainText = structuredFormatting?.main_text || '';
                              const secondaryText = structuredFormatting?.secondary_text || '';
                              const description = option?.description || rawPrediction?.description || '';
                              
                              // Use secondary text if it contains postal code, otherwise use mainText
                              // Secondary text typically has format like "NSW 2135" or "Strathfield NSW 2135"
                              let text = '';
                              if (secondaryText && /\b\d{4}\b/.test(secondaryText)) {
                                // Secondary text has postal code, use it
                                text = secondaryText;
                              } else if (mainText) {
                                // Use mainText and append secondaryText if it adds value
                                text = mainText;
                                if (secondaryText && !mainText.toLowerCase().includes(secondaryText.toLowerCase())) {
                                  // Only append if it doesn't duplicate
                                  const secondaryClean = secondaryText.replace(/, Australia$/i, '').trim();
                                  if (!text.toLowerCase().includes(secondaryClean.toLowerCase())) {
                                    text = `${text} ${secondaryClean}`;
                                  }
                                }
                              } else {
                                text = description || '';
                              }
                              
                              // Remove ", Australia" suffix if present
                              let formatted = text.replace(/, Australia$/i, '').trim();
                              
                              // Check if it's already in "Suburb State PostalCode" format (e.g., "Ashmore QLD 4214")
                              const alreadyFormatted = /^(.+?)\s+([A-Z]{2,3})\s+(\d{4})$/.test(formatted);
                              if (alreadyFormatted) {
                                return formatted;
                              }
                              
                              // Try to extract postal code from anywhere in the text (4 digits)
                              const postalCodeMatch = formatted.match(/\b(\d{4})\b/);
                              const postalCode = postalCodeMatch ? postalCodeMatch[1] : '';
                              
                              // Remove postal code from text for parsing
                              let textWithoutPostal = formatted.replace(/\b\d{4}\b/, '').trim();
                              // Clean up any double spaces or trailing commas
                              textWithoutPostal = textWithoutPostal.replace(/\s+/g, ' ').replace(/,\s*$/, '').trim();
                              
                              // Remove duplicate suburb/state patterns (e.g., "Strathfield NSW Strathfield NSW" -> "Strathfield NSW")
                              const duplicatePattern = /^(.+?)\s+([A-Z]{2,3})\s+\1\s+\2$/i;
                              if (duplicatePattern.test(textWithoutPostal)) {
                                textWithoutPostal = textWithoutPostal.replace(duplicatePattern, '$1 $2');
                              }
                              
                              // Try to parse "Suburb, State" or "Suburb State" format
                              const parts = textWithoutPostal.split(',').map(p => p.trim()).filter(p => p);
                              
                              if (parts.length >= 1) {
                                let suburb = parts[0];
                                let state = '';
                                
                                // Try to extract state from parts
                                if (parts.length >= 2) {
                                  state = parts[parts.length - 1]; // Usually state is the last part
                                } else {
                                  // Try to extract state from single part (e.g., "Ashmore QLD")
                                  const stateMatch = suburb.match(/\s+([A-Z]{2,3})$/);
                                  if (stateMatch) {
                                    state = stateMatch[1];
                                    suburb = suburb.replace(/\s+[A-Z]{2,3}$/, '').trim();
                                  }
                                }
                                
                                // Map full state names to abbreviations
                                const stateAbbrMap = {
                                  'Queensland': 'QLD',
                                  'New South Wales': 'NSW',
                                  'Victoria': 'VIC',
                                  'Western Australia': 'WA',
                                  'South Australia': 'SA',
                                  'Tasmania': 'TAS',
                                  'Northern Territory': 'NT',
                                  'Australian Capital Territory': 'ACT'
                                };
                                
                                // Convert state name to abbreviation if needed
                                let stateAbbr = state;
                                if (state) {
                                  if (stateAbbrMap[state]) {
                                    stateAbbr = stateAbbrMap[state];
                                  } else if (state.length > 3) {
                                    // Try partial match
                                    const found = Object.entries(stateAbbrMap).find(([name]) => 
                                      state.toLowerCase().includes(name.toLowerCase()) || 
                                      name.toLowerCase().includes(state.toLowerCase())
                                    );
                                    if (found) stateAbbr = found[1];
                                  } else if (/^[A-Z]{2,3}$/.test(state)) {
                                    // Already an abbreviation
                                    stateAbbr = state;
                                  }
                                }
                                
                                // Build formatted string - ensure no duplication
                                let result = suburb.trim();
                                if (stateAbbr && !result.endsWith(stateAbbr)) {
                                  result += ` ${stateAbbr}`;
                                }
                                if (postalCode && !result.includes(postalCode)) {
                                  result += ` ${postalCode}`;
                                }
                                
                                return result;
                              }
                              
                              // If we can't parse it, return as is (with postal code if found)
                              if (postalCode && formatted !== postalCode) {
                                return formatted;
                              }
                              
                              return formatted;
                            },
                            filterOption: false,
                            showSearch: true,
                          }}
                          apiOptions={{
                            language: "en",
                            componentRestrictions: { country: "au" },
                          }}
                          minLengthAutocomplete={2}
                          debounce={300}
                        />
                        {/* <GoogleComponent
                          apiKey={"AIzaSyBgimhyTUzrdCN2YF7Z81vu0WJbTECDCkA"}
                          language={"en"}
                          country={"country:au"}
                          coordinates={true}
                          locationBoxStyle={"custom-style"}
                          locationListStyle={"custom-style-list"}
                          value={address}
                          place={address}
                          defaultChecked={address}
                          onChange={(e) => {
                            form.setFieldsValue({
                              officeAddress: { ...e, ["label"]: e?.place },
                            });
                            setAddress({ ...e, ["label"]: e?.place });
                          }}
                        /> */}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={100}>
                    <Col xs={12}>
                      <Form.Item label="Billing Name*" name="billingName">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={12}>
                      <Form.Item label="Billing Email*" name="billingEmail">
                        <Input type="email" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={100}>
                    <Col xs={12}>
                      <Form.Item label="Upload Logo*" name="companyLogo">
                        <Upload
                          listType="picture-card"
                          fileList={fileList}
                          onPreview={handlePreview}
                          onChange={handleChange}
                          multiple={false}
                          accept="image/png, image/jpeg"
                          {...props}
                        >
                          {fileList?.length >= 1 ? null : uploadButton}
                        </Upload>
                        <Modal
                          centered
                          getContainer={document.body}
                          open={previewOpen}
                          title={previewTitle}
                          footer={null}
                          onCancel={handleCancel}
                        >
                          <img
                            alt="example"
                            style={{ width: "100%" }}
                            src={previewImage}
                          />
                        </Modal>
                      </Form.Item>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col xs={22}>
                          <p className="marketing_title">
                            Marketing Permission
                          </p>
                          <p className="marketing_value">
                            Receive the latest product and marketing updates{" "}
                            <br /> from Cinchy.Me and selected partners
                          </p>
                        </Col>
                        <Col xs={2} className="switch_Col">
                          <Form.Item name="marketingPermission">
                            <Switch
                              checked={marketingPermission}
                              // className="switch_toggle"
                              onChange={(e) => {
                                {
                                  form.setFieldsValue({
                                    marketingPermission: e,
                                  });
                                  setMarketingPermission(e);
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={100}>
                    <Col xs={24}>
                      <div className="tds_integration_box">
                        <div className="tds_integration_left">
                          <img
                            src={ThreeDSafetyLogo}
                            alt="3D Safety"
                            className="tds_logo"
                          />
                          <div className="tds_integration_info">
                            <p className="tds_integration_title">
                              3D Safety Integration
                            </p>
                            <p className="tds_integration_subtitle">
                              {data?.threeDSafetyClientId
                                ? "Your 3D Safety account is connected. Only an admin can update the credentials."
                                : "Connect your 3D Safety account to enable integration. Only an admin can set this up."}
                            </p>
                            <div className="tds_status_badge">
                              <span
                                className={`tds_status_dot ${
                                  data?.threeDSafetyClientId
                                    ? "tds_dot_connected"
                                    : "tds_dot_disconnected"
                                }`}
                              />
                              <span
                                className={`tds_status_label ${
                                  data?.threeDSafetyClientId
                                    ? "tds_label_connected"
                                    : "tds_label_disconnected"
                                }`}
                              >
                                {data?.threeDSafetyClientId
                                  ? "Connected"
                                  : "Not Connected"}
                              </span>
                            </div>
                          </div>
                        </div>

                        {(userData?.recruiterUserType === "Admin" ||
                          userData?.recruiterUserType === null) && (
                          <div className="tds_integration_action">
                            {data?.threeDSafetyClientId ? (
                              <Button
                                className="tds_edit_btn"
                                icon={<EditOutlined />}
                                onClick={() => {
                                  formThreeDSafety.resetFields();
                                  setThreeDSafetyModalOpen(true);
                                }}
                              >
                                Edit Credentials
                              </Button>
                            ) : (
                              <Button
                                className="tds_connect_btn"
                                onClick={() => {
                                  formThreeDSafety.resetFields();
                                  setThreeDSafetyModalOpen(true);
                                }}
                              >
                                Connect Now
                              </Button>
                            )}
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row gutter={16} justify={"end"}>
                    <Col className="buttonCol">
                      <Form.Item>
                        <Button
                          className="button_cancel"
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col className="buttonCol">
                      <Form.Item>
                        <Button
                          htmlType="submit"
                          className="button_update"
                          disabled={!isCompanyDetailsChanged}
                        >
                          Update
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Form>
            </Col>
          )}
        </Col>
        {user === "Associate" && (
          <Col
            xs={24}
            className="user_management_table_box"
            style={{ paddingTop: "20px" }}
          >
            <Table
              columns={columns}
              dataSource={campaignList}
              loading={loading}
              title={() => (
                <Row gutter={16} align={"middle"} justify={"space-between"}>
                  <Col xs={24} md={12}>
                    <Row className="justify_space_between_resp">
                      <Col xs={24} md={24}>
                        <Input.Search
                          className="searchBox searchInput"
                          allowClear
                          placeholder="Search campaign or job advert"
                          onChange={(e) => setSearch(e?.target?.value)}
                          prefix={<img src={SearchIcon} alt="search" />}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            />
            <CustomPagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              total={campaignList?.length}
              itemPerPage={10}
            />
          </Col>
        )}
      </Row>
      <Modal
        className="permission_modal"
        title="Change Permission?"
        centered
        getContainer={document.body}
        footer={null}
        open={updatePermission}
        onCancel={() => setUpdatePermission(false)}
      >
        <Row>
          <Col>
            <p className="para">
              Are you sure you want to change user type to <b>Standard User</b>?
              You will be redirected to home page after confirmation.
            </p>
          </Col>
          <Col xs={24} className="buttonCol">
            <Button className="modal_cancel">Cancel</Button>
            <Button className="modal_yes">Yes</Button>
          </Col>
        </Row>
      </Modal>
      <Modal
        className="three_d_safety_modal"
        title={
          <div className="tds_modal_title_wrap">
            <img src={ThreeDSafetyLogo} alt="3D Safety" className="tds_modal_logo" />
            <span>3D Safety Integration</span>
          </div>
        }
        centered
        getContainer={document.body}
        footer={null}
        open={threeDSafetyModalOpen}
        onCancel={() => {
          formThreeDSafety.resetFields();
          setThreeDSafetyModalOpen(false);
        }}
        destroyOnClose
      >
        <Form
          form={formThreeDSafety}
          layout="vertical"
          autoComplete="off"
          onFinish={async (values) => {
            setThreeDSafetyLoading(true);
            try {
              const payload = {
                companyName: data?.companyName,
                companyAbn: data?.companyAbn,
                officeAddress: data?.officeAddress,
                billingName: data?.billingName,
                billingEmail: data?.billingEmail,
                ...values,
              };
              await API_MANAGER.updateCompanyDetails(payload);
              message.success("3D Safety credentials saved successfully.");
              setThreeDSafetyModalOpen(false);
              formThreeDSafety.resetFields();
              getUserData();
            } catch (error) {
              message.error("Something went wrong. Please try again.");
            }
            setThreeDSafetyLoading(false);
          }}
        >
          <Form.Item
            label="Client ID"
            name="threeDSafetyClientId"
            rules={[{ required: true, message: "Please enter the Client ID" }]}
          >
            <Input
              placeholder="Enter your 3D Safety Client ID"
              autoComplete="off"
            />
          </Form.Item>
          <Form.Item
            label="Client Secret"
            name="threeDSafetyClientSecret"
            rules={[{ required: true, message: "Please enter the Client Secret" }]}
          >
            <Input.Password
              placeholder="Enter your 3D Safety Client Secret"
              autoComplete="new-password"
            />
          </Form.Item>
          <Row justify="end" gutter={12} className="tds_modal_actions">
            <Col>
              <Button
                className="tds_modal_cancel_btn"
                onClick={() => {
                  formThreeDSafety.resetFields();
                  setThreeDSafetyModalOpen(false);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className="tds_modal_save_btn"
                htmlType="submit"
                loading={threeDSafetyLoading}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </SubLayout>
  );
}
export default EditProfile;
